import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, IconButton, Stack, Typography} from 'views/components';
import {DeleteOutline} from 'views/icons';
import {AssigneeBadge} from '../../../components';

const PlaybooksEngagementPreview = (props) => {
  const {
    rules = [],
    setRules,
  } = props;

  const onSelectAdmin = (ruleIndex, ownerRn, admin) => {
    setRules((currentRules) => currentRules.map((rule, index) => {
      if (index !== ruleIndex) {
        return rule;
      }

      if (!ownerRn) {
        const nextOwnerRns = [...new Set([...(rule.ownerRns || []), admin.userRn])];

        return {
          ...rule,
          ownerRns: nextOwnerRns,
        };
      }

      return {
        ...rule,
        ownerRns: (rule.ownerRns || []).map((currentOwnerRn) => (
          currentOwnerRn === ownerRn ? admin.userRn : currentOwnerRn
        )),
      };
    }));
  };

  const onUnassign = (ruleIndex, ownerRn) => {
    setRules((currentRules) => currentRules.map((rule, index) => {
      if (index !== ruleIndex) {
        return rule;
      }

      return {
        ...rule,
        ownerRns: (rule.ownerRns || []).filter((currentOwnerRn) => currentOwnerRn !== ownerRn),
      };
    }));
  };

  const onDeleteRule = (ruleIndex) => {
    setRules((currentRules) => currentRules.filter((_rule, index) => index !== ruleIndex));
  };

  return (
    <Box
      sx={{
        borderRadius: '12px',
        px: '14px',
        py: '12px',
      }}
    >
      {
        rules.map((rule, index) => (
          <React.Fragment key={rule.engagementRuleRn || `${rule.prompt || 'rule'}-${index}`}>
            <Stack
              sx={{
                'gap': '10px',
                'py': '12px',
                '&:hover .playbook-rule-delete': {
                  opacity: 1,
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#A8A49E',
                  lineHeight: '150%',
                  textTransform: 'uppercase',
                }}
              >
                Rule {index + 1}
              </Typography>
              <Stack direction='row' sx={{gap: '12px'}}>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 500,
                    color: '#1A1916',
                    lineHeight: '150%',
                    ml: '20px',
                    color: '#A8A49E',
                  }}
                >
                  <span>&bull;</span>
                </Typography>
                <Typography
                  sx={{
                    fontSize: '13px',
                    fontWeight: 500,
                    color: '#1A1916',
                    lineHeight: '150%',
                  }}
                >
                  {rule.prompt}
                </Typography>
                <Stack
                  direction='row'
                  sx={{
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '8px',
                    ml: 'auto',
                  }}
                >
                  <Stack
                    direction='row'
                    sx={{
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    {
                      [...((rule.ownerRns && rule.ownerRns.length > 0) ? rule.ownerRns : []), null].map((ownerRn, ownerIndex) => (
                        <AssigneeBadge
                          key={`${rule.engagementRuleRn || index}-${ownerRn || 'unassigned'}`}
                          user={ownerRn ? {userRn: ownerRn} : {}}
                          sx={{
                            width: '24px',
                            height: '24px',
                            position: 'relative',
                            zIndex: ownerIndex + 1,
                            fontSize: '11px',
                            outline: '2px solid',
                            outlineColor: '#FFFFFF',
                            ml: ownerIndex === 0 ? 0 : '-6px',
                          }}
                          onSelectAdmin={(admin) => onSelectAdmin(index, ownerRn, admin)}
                          onUnassign={ownerRn ? () => onUnassign(index, ownerRn) : undefined}
                        />
                      ))
                    }
                  </Stack>
                  <IconButton
                    className='playbook-rule-delete'
                    onClick={() => onDeleteRule(index)}
                    sx={{
                      'width': '24px',
                      'height': '24px',
                      'color': '#A8A49E',
                      'opacity': 0,
                      'transition': 'opacity 0.15s ease',
                      '&:hover': {
                        backgroundColor: 'transparent',
                        color: '#6B6760',
                      },
                    }}
                  >
                    <DeleteOutline sx={{fontSize: '16px'}} />
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
            {
              index < rules.length - 1 &&
              <Divider />
            }
          </React.Fragment>
        ))
      }
    </Box>
  );
};

PlaybooksEngagementPreview.propTypes = {
  rules: PropTypes.array,
  setRules: PropTypes.func.isRequired,
};

export default React.memo(PlaybooksEngagementPreview);
